import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CloseOutline } from '@styled-icons/evaicons-outline';
import NumberInput from 'Components/Forms/NumberInput';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

const ControlBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  width: '100%',
}));

const StyledNumberInput = styled(props => <NumberInput {...props} />)(() => ({
  width: 120,

  '& input': {
    textAlign: 'end',
  },

  svg: {
    color: '#000000',
  },
}));

const StyledCloseIcon = styled(CloseOutline)(({ theme }) => ({
  margin: theme.spacing(1),
}));

const ControlBarCropping = ({ onClose, onSubmit }) => {
  return (
    <ControlBar>
      <Box display="flex" alignItems="center">
        <Box mr={2.5}>
          <Typography variant="h6">Crop Image</Typography>
        </Box>
        <Box>
          <Field
            name="width"
            variant="outlined"
            type="number"
            unit="px"
            component={StyledNumberInput}
          />
          <StyledCloseIcon size={20} />
          <Field
            name="height"
            type="number"
            variant="outlined"
            unit="px"
            component={StyledNumberInput}
          />
        </Box>
      </Box>
      <Box display="flex">
        <Box mr={1.5}>
          <ThemeButton color="BLUE_ICE" onClick={onClose} size="large">
            Cancel
          </ThemeButton>
        </Box>
        <ThemeButton color="PRIMARY" type="submit" onClick={onSubmit} size="large">
          Apply
        </ThemeButton>
      </Box>
    </ControlBar>
  );
};

ControlBarCropping.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ControlBarCropping;
